<template>
	<v-layout row wrap>
		<v-flex xs12 md12>
			<v-text-field
				v-model="item.shipping"
				type="number"
				:label="$t('label.shipping')"
				v-validate="''"
				data-vv-name="shipping"
				:error-messages="errors.collect('shipping')"
			></v-text-field>
		</v-flex>
		<v-flex xs12>
			<v-autocomplete
				:items="drivers"
				item-value="id"
				item-text="name"
				:label="$t('title.driver')"
				v-model="item.driver_id"
				v-validate="''"
				data-vv-name="driver_id"
				:error-messages="errors.collect('driver_id')"
			>
			</v-autocomplete>
		</v-flex>
		<v-flex xs12>
			<v-autocomplete
				:items="addresses"
				item-value="id"
				item-text="name"
				:label="$t('Address')"
				v-model="item.address_id"
				v-validate="''"
				data-vv-name="address_id"
				:error-messages="errors.collect('address_id')"
			>
			</v-autocomplete>
		</v-flex>
		<template v-if="!item.address_id">
			<v-flex xs12 md6>
				<v-text-field
					v-model="item.delivery.contact_person"
					:label="$t('label.contact_person')"
					v-validate="'required'"
					data-vv-name="delivery.contact_person"
					:error-messages="errors.collect('delivery.contact_person')"
				></v-text-field>
			</v-flex>
			<v-flex xs12 md6>
				<v-text-field
					v-model="item.delivery.phone_number"
					:label="$t('Phone Number')"
					v-validate="'required'"
					data-vv-name="delivery.phone_number"
					:error-messages="errors.collect('delivery.phone_number')"
				></v-text-field>
			</v-flex>
			<v-flex xs12 md12>
				<v-text-field
					v-model="item.delivery.address"
					:label="$t('Address')"
					v-validate="'required'"
					data-vv-name="delivery.address"
					:error-messages="errors.collect('delivery.address')"
				></v-text-field>
			</v-flex>
			<v-flex xs12>
				<lazy-google-map-component
					v-if="item.delivery.latitude && item.delivery.longitude"
					:lat="item.delivery.latitude"
					:lng="item.delivery.longitude"
					@updateLatLng="updateLatLng"
				></lazy-google-map-component>
			</v-flex>
		</template>
	</v-layout>
</template>

<script>
export default {
	props: ["value"],
	data() {
		return {
			addresses: [],
			drivers: [],
		};
	},

	computed: {
		item() {
			if (!this.value.delivery) {
				this.value.delivery = {};
			}
			return this.value;
		},
	},

	watch: {
		item: {
			handler() {
				this.$emit("input", this.item);
			},
			immediate: true,
		},
	},
};
</script>